import { useCallback, useRef } from 'react';
import { testMediaConnectionBitrate, MediaConnectionBitrateTest } from '@twilio/rtc-diagnostics';
import { ACTIONTYPE } from '../AppStateProvider';

export default function useBitrateTestUDP(dispatch: React.Dispatch<ACTIONTYPE>) {
  const bitrateTestRef = useRef<MediaConnectionBitrateTest>();
  const startBitrateUDPTest = useCallback(() => {
    //Don't start a new bitrate test if one is already running:
    if (bitrateTestRef.current) {
      return;
    }

    dispatch({ type: 'udp-bitrate-test-started' });

    return new Promise(() => {
      const bitrateTest = testMediaConnectionBitrate({
        iceServers: [
          {
            urls: [process.env.REACT_APP_TURN_SERVER_URL_UDP!],
            username: process.env.REACT_APP_TURN_SERVER_USERNAME,
            credential: process.env.REACT_APP_TURN_SERVER_PASSWORD,
          },
        ],
      });

      bitrateTestRef.current = bitrateTest;

      bitrateTest.on(MediaConnectionBitrateTest.Events.Bitrate, (bitrate) => {
        dispatch({ type: 'udp-set-bitrate', bitrate });
      });

      bitrateTest.on(MediaConnectionBitrateTest.Events.Error, (error) => {
        dispatch({ type: 'udp-set-bitrate-test-error', error });
        dispatch({ type: 'udp-bitrate-test-finished' });
      });

      bitrateTest.on(MediaConnectionBitrateTest.Events.End, (report) => {
        dispatch({ type: 'udp-set-bitrate-test-report', report });
        dispatch({ type: 'udp-bitrate-test-finished' });
      });

      setTimeout(() => {
        bitrateTest.stop();
      }, 5000);
    }).catch((error) => {
      dispatch({ type: 'udp-set-bitrate-test-error', error });
      dispatch({ type: 'udp-bitrate-test-finished' });
    });
  }, [dispatch]);

  return startBitrateUDPTest;
}
